setTimeout(() => {
  // Add aria-labels to social media and external links opening in new tabs
  document
    .querySelectorAll(
      'a.social-link[target="_blank"]:not([aria-label]), a[href*="authorize.net"][target="_blank"]:not([aria-label])'
    )
    .forEach((link) => {
      const href = link.getAttribute("href") || "";
      let label = "";

      if (href.startsWith("mailto:")) {
        const email = href.replace("mailto:", "");
        label = `Email us at ${email} (opens in a new tab)`;
      } else if (href.includes("facebook.com")) {
        label = "Visit us on Facebook (opens in a new tab)";
      } else if (href.includes("instagram.com")) {
        label = "Visit us on Instagram (opens in a new tab)";
      } else if (href.includes("linkedin.com")) {
        label = "Visit us on LinkedIn (opens in a new tab)";
      } else if (href.includes("pinterest.com")) {
        label = "Visit us on Pinterest (opens in a new tab)";
      } else if (href.includes("youtube.com")) {
        label = "Visit us on YouTube (opens in a new tab)";
      } else if (href.includes("x.com") || href.includes("twitter.com")) {
        label = "Visit us on X (formerly Twitter) (opens in a new tab)";
      } else if (href.includes("authorize.net")) {
        label = "Authorize.net site verification (opens in a new tab)";
      }

      link.setAttribute("aria-label", label);
    });

    // Add role="region" and aria-label to promo mosaic section for better accessibility
    const div = document.querySelector('div[id^="shopify-section-template--"][class*="promo-mosaic"]');
    if (div && div.tagName === "DIV") {
        div.setAttribute("role", "region");
        div.setAttribute("aria-label", "Promotional Section");
    }
}, 3000);

// Observe DOM changes to fix missing alt attribute on klaviyo popup logo image
const observer = new MutationObserver(() => {
  const elements = document.getElementsByClassName('kl-private-reset-css-Xuajs1');

  for (let i = 0; i < elements.length; i++) {
    const el = elements[i];

    if (el.tagName === 'IMG' && !el.hasAttribute('alt')) {
      el.setAttribute('alt', 'ReadyHour logo');
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
